(function () {
  'use strict';
  const ROOT = '[data-wb-root]';
  const DATA = '[data-wb-data]';
  const CARDS = '[data-wb-cards]';
  const VBLOCK = '[data-wb-variant-block]';
  const VG2 = '[data-wb-variant-group="2"]';
  const VO1 = '[data-wb-variant-options="1"]';
  const VO2 = '[data-wb-variant-options="2"]';
  const SAMT = '[data-wb-amount]';
  const SCMP = '[data-wb-compare]';
  const KW_RE = /^\s*(mod[èée]le|couleur|colou?r|taille|size)\s*[: \*\.\-]*\s*$/i;

  const FORMS = ['form[action*="/cart/add"]', '[data-product-form]', 'product-form form'];
  const GIMG = ['[data-product-featured-image] img', '.product__media img', '.product-gallery__main img', '.product-single__photo img', '[data-zoom-image]', '.featured-image img', '.productImages img', '.product-image img'];
  const PRICE = ['[data-product-price]', '.price__regular .price-item--regular', '.product__price', '.price__current', '.product-price', '#price-preview', '.prodPrice', '.product_price', '.prod_price', '.priceCurrent'];
  const CPRICE = ['[data-compare-price]', '.price__sale .price-item--sale', '.price__compare', '.compare-at-price', '.priceCompare'];

  const NATIVE_PATTERNS = ['[data-option-index]', '.swatch', '.selector-wrapper', '.single-option-selector', '.product-form__input', '.variant-input-wrap', '.product-options', '.productOptions', '.product-form__variants', '.swatches', '.product-form-grid', '.product-options-table', '.singleVariant', '.variants-wrapper', '.variant-options', '.product-single__variants', '.optionsCD', '.opcd', '.opcd-radio', '.option-cd', '.fl-options', '.cd-options', '.product-variants', '.product-form-variants', '.option-selection', '.variant-selectors', '.product-form__option', '.product__option', 'fieldset[name*="variant"]'];

  function $(s, sc) { return (sc || document).querySelector(s); }
  function $$(s, sc) { return Array.from((sc || document).querySelectorAll(s)); }
  function normalize(s) { return (s || '').toString().toLowerCase().trim().replace(/[: \*\.\-\s]+$/, '').trim(); }

  function fmt(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (!isFinite(cents)) return '';
    const v = (cents / 100).toFixed(2).replace('.', ',');
    if (!format) return v + ' €';
    return format.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, v).replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/g, Math.round(cents / 100).toString()).replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, v);
  }

  function firstOf(sels, sc) { for (const s of sels) { const e = $(s, sc); if (e) return e; } return null; }
  function updImg(u) { const img = firstOf(GIMG); if (img && u) { img.src = u; img.srcset = ''; } }
  function updPrice(v, mf) { const p = firstOf(PRICE), c = firstOf(CPRICE); if (p) p.textContent = fmt(v.price, mf); if (c) { if (v.compare_at_price && v.compare_at_price > v.price) { c.textContent = fmt(v.compare_at_price, mf); c.hidden = false; } else { c.textContent = ''; c.hidden = true; } } }
  function updForm(vid) { const v = String(vid); let done = false; $$('form[action*="/cart/add"]').forEach(function (f) { const fl = $$('[name="id"]', f); if (!fl.some(function (el) { return el.tagName === 'SELECT' && !!el.querySelector('option[value="' + v + '"]'); })) return; fl.forEach(function (el) { el.value = v; }); done = true; }); if (done) return; const f = firstOf(FORMS); if (!f) return; let i = f.querySelector('[name="id"]'); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'id'; f.prepend(i); } i.value = v; }
  function updSub(root, v, mf) { const a = $(SAMT, root), c = $(SCMP, root); if (a) a.textContent = fmt(v.price, mf); if (c) { if (v.compare_at_price && v.compare_at_price > v.price) { c.textContent = fmt(v.compare_at_price, mf); c.hidden = false; } else c.hidden = true; } }
  function applyV(root, prod, v, mf) { const url = (v.featured_image && v.featured_image.src) || v.featured_image || prod.featured_image; updImg(url); updPrice(v, mf); updForm(v.id); updSub(root, v, mf); root.dispatchEvent(new CustomEvent('wb:variant-changed', { detail: { product: prod, variant: v }, bubbles: true })); }

  function parseV(v, mode, sep) {
    if (mode === 'split_option_1' && v.option1) {
      const i = v.option1.indexOf(sep);
      if (i > -1) return { ck: v.option1.slice(0, i).trim(), col: v.option1.slice(i + sep.length).trim(), sz: v.option2 };
      return { ck: v.option1, col: null, sz: v.option2 };
    }
    return { ck: v.option1, col: v.option2, sz: v.option3 };
  }

  function groupB(prod, mode, sep) {
    const g = new Map();
    prod.variants.forEach(function (v) {
      const p = parseV(v, mode, sep);
      const k = p.ck;
      if (!g.has(k)) g.set(k, { ck: k, variants: [] });
      g.get(k).variants.push(Object.assign({}, v, { _p: p }));
    });
    return g;
  }

  function imgFromVariant(v) {
    if (!v || !v.featured_image) return null;
    return typeof v.featured_image === 'string' ? v.featured_image : (v.featured_image.src || v.featured_image);
  }

  /* Find the best matching variant in a group for given color + size, with fallbacks */
  function matchVariant(group, color, size) {
    if (color && size) {
      const m = group.variants.find(function (v) { return v._p.col === color && v._p.sz === size; });
      if (m) return m;
    }
    if (color) {
      const m = group.variants.find(function (v) { return v._p.col === color; });
      if (m) return m;
    }
    if (size) {
      const m = group.variants.find(function (v) { return v._p.sz === size; });
      if (m) return m;
    }
    return group.variants[0];
  }

  function pickImageForCard(group, prod, idx, currentColor, currentSize) {
    if (currentColor && currentSize) {
      const exact = group.variants.find(function (v) { return v._p.col === currentColor && v._p.sz === currentSize && v.featured_image; });
      if (exact) return imgFromVariant(exact);
    }
    if (currentColor) {
      const m = group.variants.find(function (v) { return v._p.col === currentColor && v.featured_image; });
      if (m) return imgFromVariant(m);
    }
    if (currentSize) {
      const m = group.variants.find(function (v) { return v._p.sz === currentSize && v.featured_image; });
      if (m) return imgFromVariant(m);
    }
    const anyWithImage = group.variants.find(function (v) { return v.featured_image; });
    if (anyWithImage) return imgFromVariant(anyWithImage);
    if (prod.images && prod.images[idx]) return prod.images[idx];
    return prod.featured_image;
  }

  /* Update card images + per-card price/compare/discount based on current selection */
  function updateCardsDisplay(root, groups, prod, color, size, mf) {
    const cards = $$('[data-wb-card]', root);
    let i = 0;
    groups.forEach(function (group, key) {
      const card = cards.find(function (c) { return c.dataset.cardKey === key; });
      if (!card) { i++; return; }

      /* Update image */
      const newImg = pickImageForCard(group, prod, i, color, size);
      const imgEl = card.querySelector('.wb-card__thumb img');
      if (imgEl && newImg && imgEl.src !== newImg) {
        imgEl.style.transition = 'opacity 0.18s ease';
        imgEl.style.opacity = '0.25';
        const preload = new Image();
        preload.onload = function () { imgEl.src = newImg; imgEl.style.opacity = '1'; };
        preload.onerror = function () { imgEl.style.opacity = '1'; };
        preload.src = newImg;
      }

      /* Update price + compare + discount based on matched variant */
      const variant = matchVariant(group, color, size);
      const priceEl = card.querySelector('[data-wb-card-price]');
      const compareEl = card.querySelector('[data-wb-card-compare]');
      const discEl = card.querySelector('[data-wb-card-discount]');
      if (variant) {
        const p = parseInt(variant.price, 10) || 0;
        const cmp = variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
        const hasDisc = cmp > p;
        if (priceEl) priceEl.textContent = fmt(p, mf);
        if (compareEl) {
          if (hasDisc) { compareEl.textContent = fmt(cmp, mf); compareEl.hidden = false; compareEl.style.display = ''; }
          else { compareEl.textContent = ''; compareEl.hidden = true; compareEl.style.display = 'none'; }
        }
        if (discEl) {
          if (hasDisc) {
            const disc = Math.round(((cmp - p) / cmp) * 100);
            discEl.textContent = '-' + disc + '%';
            discEl.hidden = false; discEl.style.display = '';
          } else {
            discEl.textContent = ''; discEl.hidden = true; discEl.style.display = 'none';
          }
        }
      }
      i++;
    });
  }

  function renderB(root, prod, groups, mf) {
    const cont = $(CARDS, root); if (!cont) return; cont.innerHTML = ''; let i = 0;
    groups.forEach(function (group, key) {
      const anyAvail = group.variants.some(function (v) { return v.available; });
      const img = pickImageForCard(group, prod, i, null, null);
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'wb-card'; b.dataset.wbCard = '1'; b.dataset.cardKey = key;
      b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      b.setAttribute('aria-label', key);
      if (!anyAvail) b.setAttribute('data-unavailable', 'true');
      b.innerHTML = '<span class="wb-card__discount" data-wb-card-discount hidden></span>' +
        '<span class="wb-card__check" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></span>' +
        '<span class="wb-card__thumb">' + (img ? '<img src="' + img + '" alt="' + esc(key) + '" loading="lazy" width="150" height="150">' : '<span class="wb-card__placeholder">' + esc(key.slice(0, 2).toUpperCase()) + '</span>') + '</span>' +
        '<span class="wb-card__body">' +
          '<span class="wb-card__title">' + esc(key) + '</span>' +
          '<span class="wb-card__price-row">' +
            '<span class="wb-card__price" data-wb-card-price></span>' +
            '<span class="wb-card__compare" data-wb-card-compare hidden></span>' +
          '</span>' +
        '</span>';
      cont.appendChild(b); i++;
    });
  }

  function selCardB(root, ck, groups, prod, mf) {
    /* Capture current color + size BEFORE rebuilding selectors */
    const o1 = $(VO1, root);
    const o2 = $(VO2, root);
    const prevColorBtn = o1 ? o1.querySelector('.wb-variant-option--selected') : null;
    const prevSizeBtn = o2 ? o2.querySelector('.wb-variant-option--selected') : null;
    if (prevColorBtn) root._wbPrefColor = (prevColorBtn.dataset.color || prevColorBtn.textContent || '').trim();
    if (prevSizeBtn) root._wbPrefSize = (prevSizeBtn.textContent || '').trim();

    $$('[data-wb-card]', root).forEach(function (c) { c.classList.remove('wb-card--selected'); c.setAttribute('aria-checked', 'false'); });
    const c = $$('[data-wb-card]', root).find(function (x) { return x.dataset.cardKey === ck; });
    if (c) { c.classList.add('wb-card--selected'); c.setAttribute('aria-checked', 'true'); }
    buildColB(root, ck, groups, prod, mf);
  }

  function buildColB(root, ck, groups, prod, mf) {
    const blk = $(VBLOCK, root), o1 = $(VO1, root); if (!blk || !o1) return; o1.innerHTML = '';
    const g = groups.get(ck); if (!g) return;
    const cols = [], seen = new Set();
    g.variants.forEach(function (v) { const c = v._p.col; if (c && !seen.has(c)) { seen.add(c); cols.push(c); } });
    blk.hidden = false; blk.removeAttribute('hidden'); blk.style.display = '';
    const g1 = root.querySelector('[data-wb-variant-group="1"]');
    if (cols.length === 0) { if (g1) { g1.hidden = true; g1.style.display = 'none'; } buildSzB(root, ck, null, groups, prod, mf); return; }
    if (g1) { g1.hidden = false; g1.removeAttribute('hidden'); g1.style.display = ''; }
    cols.forEach(function (color) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'wb-variant-option'; b.textContent = color; b.dataset.color = color;
      b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      const av = g.variants.some(function (v) { return v._p.col === color && v.available; });
      if (!av) b.disabled = true;
      b.addEventListener('click', function () {
        if (b.disabled) return;
        $$('.wb-variant-option', o1).forEach(function (x) { x.classList.remove('wb-variant-option--selected'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('wb-variant-option--selected'); b.setAttribute('aria-checked', 'true');
        root._wbPrefColor = color;
        updateCardsDisplay(root, groups, prod, color, null, mf);
        buildSzB(root, ck, color, groups, prod, mf);
      });
      o1.appendChild(b);
    });
    /* Preselect: preferred color from previous state, else first available */
    let preselect = null;
    const prefColor = root._wbPrefColor;
    if (prefColor) {
      preselect = $$('.wb-variant-option', o1).find(function (b) { return b.dataset.color === prefColor && !b.disabled; });
    }
    if (!preselect) preselect = $$('.wb-variant-option', o1).find(function (b) { return !b.disabled; });
    if (!preselect) preselect = $$('.wb-variant-option', o1)[0];
    if (preselect) preselect.click();
  }

  function buildSzB(root, ck, color, groups, prod, mf) {
    const o2 = $(VO2, root), g2 = $(VG2, root); if (!o2 || !g2) return; o2.innerHTML = '';
    const g = groups.get(ck); if (!g) return;
    const vars = color ? g.variants.filter(function (v) { return v._p.col === color; }) : g.variants;
    const sizes = vars.map(function (v) { return { sz: v._p.sz, v: v }; }).filter(function (x) { return x.sz != null; });
    if (sizes.length === 0) {
      g2.hidden = true; g2.style.display = 'none';
      if (vars[0]) { applyV(root, prod, vars[0], mf); updateCardsDisplay(root, groups, prod, color, null, mf); }
      return;
    }
    g2.hidden = false; g2.removeAttribute('hidden'); g2.style.display = '';
    sizes.forEach(function (it) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'wb-variant-option'; b.textContent = it.sz; b.dataset.variantId = String(it.v.id);
      b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      if (!it.v.available) b.disabled = true;
      b.addEventListener('click', function () {
        if (b.disabled) return;
        $$('.wb-variant-option', o2).forEach(function (x) { x.classList.remove('wb-variant-option--selected'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('wb-variant-option--selected'); b.setAttribute('aria-checked', 'true');
        root._wbPrefSize = it.sz;
        applyV(root, prod, it.v, mf);
        updateCardsDisplay(root, groups, prod, color, it.sz, mf);
      });
      o2.appendChild(b);
    });
    /* Preselect: preferred size from previous state, else first available */
    let preselect = null;
    const prefSize = root._wbPrefSize;
    if (prefSize) {
      preselect = $$('.wb-variant-option', o2).find(function (b) { return b.textContent.trim() === prefSize && !b.disabled; });
    }
    if (!preselect) preselect = $$('.wb-variant-option', o2).find(function (b) { return !b.disabled; });
    if (!preselect) preselect = $$('.wb-variant-option', o2)[0];
    if (preselect) preselect.click();
  }

  function initB(root, data, mf) {
    const prod = data.product; const mode = data.mode; const sep = data.separator || '-';
    const groups = groupB(prod, mode, sep);
    renderB(root, prod, groups, mf);
    /* Initial card display update with no specific color/size */
    updateCardsDisplay(root, groups, prod, null, null, mf);
    $$('[data-wb-card]', root).forEach(function (c) {
      c.addEventListener('click', function () { selCardB(root, c.dataset.cardKey, groups, prod, mf); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selCardB(root, c.dataset.cardKey, groups, prod, mf); } });
    });
    const first = Array.from(groups.keys())[0];
    if (first) selCardB(root, first, groups, prod, mf);
    return { prod: prod, mode: mode, sep: sep };
  }

  function collectKeywords(prod, mode, sep) {
    const k = new Set();
    prod.variants.forEach(function (v) {
      if (v.option1) k.add(v.option1.trim());
      if (v.option2) k.add(v.option2.trim());
      if (v.option3) k.add(v.option3.trim());
      if (mode === 'split_option_1' && v.option1) { const i = v.option1.indexOf(sep); if (i > -1) { k.add(v.option1.slice(0, i).trim()); k.add(v.option1.slice(i + sep.length).trim()); } }
    });
    return k;
  }

  function getScanRoots(form) {
    const roots = [form];
    ['.productInfo', '.product-info', '.product__info', '.product-form-wrapper', '.product-main', '.product-single', '.product-details', '#productHead'].forEach(function (sel) {
      const el = document.querySelector(sel);
      if (el && !roots.includes(el)) roots.push(el);
    });
    return roots;
  }

  function isVariantLabel(txt, optionNamesNormalized) {
    if (!txt) return false;
    if (KW_RE.test(txt)) return true;
    const n = normalize(txt);
    if (!n) return false;
    return optionNamesNormalized.indexOf(n) !== -1;
  }

  function findMoveTarget(form, optionNamesNormalized) {
    const scanRoots = getScanRoots(form);
    let earliest = null;
    let earliestPos = Infinity;
    scanRoots.forEach(function (sr) {
      sr.querySelectorAll('*').forEach(function (el) {
        if (el.children.length > 2) return;
        const txt = (el.textContent || '').trim();
        if (!txt || txt.length > 50) return;
        if (!isVariantLabel(txt, optionNamesNormalized)) return;
        const top = el.getBoundingClientRect().top + window.scrollY;
        if (top < earliestPos) { earliestPos = top; earliest = el; }
      });
    });
    if (earliest) return earliest;
    for (const sel of NATIVE_PATTERNS) { const t = form.querySelector(sel); if (t) return t; }
    const q = form.querySelector('input[name="quantity"], .quantity-wrap, .product-quantity, button[name="add"], button[type="submit"]');
    if (q) return q.closest('div, fieldset, .product-form__input') || q;
    return null;
  }

  function moveAndHide(root, ctx) {
    const form = firstOf(FORMS); if (!form) return;
    let section = root.closest('section') || root.closest('.shopify-section') || root.parentElement;
    if (!section || section === document.body) section = root;

    const optionNames = (ctx && ctx.prod && ctx.prod.options) || [];
    const optionNamesNormalized = optionNames.map(function (n) { return normalize(n); }).filter(function (n) { return n; });

    const target = findMoveTarget(form, optionNamesNormalized);
    if (target && target.parentNode) { try { target.parentNode.insertBefore(section, target); } catch (e) {} }
    else { try { form.prepend(section); } catch (e) {} }

    const scanRoots = getScanRoots(form);
    if (section.parentElement && !scanRoots.includes(section.parentElement)) scanRoots.push(section.parentElement);

    scanRoots.forEach(function (sr) {
      NATIVE_PATTERNS.forEach(function (sel) {
        sr.querySelectorAll(sel).forEach(function (el) {
          if (!el.contains(section) && !section.contains(el)) { el.style.setProperty('display', 'none', 'important'); el.setAttribute('data-wb-hidden', '1'); }
        });
      });
    });

    scanRoots.forEach(function (sr) {
      sr.querySelectorAll('select[name*="options"], select[id*="ProductSelect-option"], select[id*="product-select"]').forEach(function (el) {
        if (section.contains(el)) return;
        const wrap = el.closest('div, fieldset, .product-form__input, .selector-wrapper, .swatch') || el;
        wrap.style.setProperty('display', 'none', 'important'); wrap.setAttribute('data-wb-hidden', '1');
      });
    });

    scanRoots.forEach(function (sr) {
      sr.querySelectorAll('*').forEach(function (el) {
        if (section.contains(el)) return;
        if (el === section || el === form) return;
        if (el.getAttribute && el.getAttribute('data-wb-hidden')) return;
        if (el.children && el.children.length > 0) return;
        const txt = (el.textContent || '').trim();
        if (!txt || txt.length > 50) return;
        if (!isVariantLabel(txt, optionNamesNormalized)) return;
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('data-wb-hidden', '1');
      });
    });

    if (section.parentElement) {
      Array.from(section.parentElement.children).forEach(function (sib) {
        if (sib === section || sib.contains(section) || section.contains(sib)) return;
        const hasVariant = sib.querySelector('[data-option-index], .swatch, .single-option-selector, select[name*="options"], .opcd, .optionsCD');
        if (hasVariant) { sib.style.setProperty('display', 'none', 'important'); sib.setAttribute('data-wb-hidden', '1'); }
      });
    }

    if (ctx && ctx.prod) {
      const keywords = collectKeywords(ctx.prod, ctx.mode, ctx.sep);
      scanRoots.forEach(function (sr) {
        sr.querySelectorAll('button, a, input[type="radio"], label').forEach(function (btn) {
          if (section.contains(btn)) return;
          if (btn.getAttribute('data-wb-hidden')) return;
          const txt = (btn.textContent || btn.value || '').trim();
          if (!txt || txt.length > 40) return;
          if (!keywords.has(txt)) return;
          let wrap = btn;
          for (let i = 0; i < 6; i++) {
            if (!wrap || wrap === form || wrap === document.body) break;
            const par = wrap.parentElement;
            if (!par || par === document.body) break;
            if (section.contains(par) || par.contains(section)) break;
            const variantBtns = Array.from(par.querySelectorAll('button, a, input[type="radio"], label')).filter(function (b) { return keywords.has((b.textContent || b.value || '').trim()); });
            if (variantBtns.length >= 2 || par.children.length <= 8) {
              wrap = par;
              if (!section.contains(wrap) && !wrap.contains(section)) { wrap.style.setProperty('display', 'none', 'important'); wrap.setAttribute('data-wb-hidden', '1'); }
              break;
            }
            wrap = par;
          }
        });
      });
    }
  }

  function esc(s) { if (s == null) return ''; return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init() {
    $$(ROOT).forEach(function (root) {
      if (root.dataset.wbInitialized === '1') return;
      root.dataset.wbInitialized = '1';
      document.body.classList.add('wb-active');
      const mode = root.dataset.wbMode || 'none';
      const mf = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
      const ds = $(DATA, root.parentElement) || $(DATA);
      if (!ds) return;
      let p; try { p = JSON.parse(ds.textContent.trim()); } catch (e) { return; }
      let ctx = null;
      if (mode === 'split_option_1' || mode === 'by_option_1') ctx = initB(root, p, mf);
      setTimeout(function () { moveAndHide(root, ctx); }, 30);
      setTimeout(function () { moveAndHide(root, ctx); }, 500);
      setTimeout(function () { moveAndHide(root, ctx); }, 1500);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('turbo:load', init);
})();